import { MetaReducer } from '@ngrx/store';

import { resetShipmentFeatureState } from './reset-shipment-feature.metareducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const metaReducers: MetaReducer<any>[] = [resetShipmentFeatureState];

export * from './reset-shipment-feature.metareducer';

